


























































































































































































































import Vue from "vue";
import Valid, { EMAIL_REGEX } from "../utils/valid";
import AuthStore from "@/store/modules/AuthStore";
import { PersonaCreateDto } from "@/api/AuthService";
import ProvinciaService from "@/api/pedido/ProvinciaService";

type VForm = Vue & {
  validate: () => boolean;
};
export default Vue.extend({
  metaInfo: {
    title: "Registro",
  },
  data() {
    return {
      fechaHoy: new Date(),
      politicas: false,
      discapacitado: false,
      carnetConadis: "",
      nombre: "",
      apellido: "",
      rules: [(v: string) => !!v || "Campo requerido"],
      sexo: "",
      email: "",
      emailConfirmation: "",
      emailRules: [
        (v: string) => !!v || "Campo requerido",
        (v: string) => EMAIL_REGEX.test(v) || "El correo no es válido",
      ],
      password: "",
      password2: "",
      showPass1: false,
      showPass2: false,
      passRules: [
        (v: string) =>
          v.length >= 8 || "La contraseña debe tener por lo menos 8 caracteres",
      ],
      celularRules: [
        (v: string) => !!v || "Campo requerido",
        (v: string) => v.length === 10 || "El celular debe tener 10 números",
      ],

      tipoid: "CED",
      identificacion: "",
      // antiguo
      cedulaRules: [
        (v: string) => !!v || "Campo requerido",
        //(v: string) => Valid.identificacionValida(v) || "La cédula no es válida"
        (v: string) =>
          (v.length === 10 && Valid.identificacionValida(v)) ||
          "La cédula no es válida",
      ],
      // nuevo
      carnetConadisRules: [(v: string) => !!v || "Campo requerido"],
      rucRules: [
        (v: string) => !!v || "Campo requerido",
        (v: string) =>
          (v.length === 13 && Valid.identificacionValida(v)) ||
          "El RUC no es válido",
      ],

      // fin
      pasaporteRules: [(v: string) => !!v || "Campo requerido"],
      telefono: "",
      country: "ECUADOR",
      province: "",
      canton: "",
      ciudad: "",
      direccion: "",
      referencias: "",
      googlemap: "",
      items: ["Cédula", "Pasaporte", "RUC"],
      identidadItems: [
        { text: "Cédula", value: "CED" },
        { text: "RUC", value: "RUC" },
        { text: "Pasaporte", value: "PAS" },
      ],
      ///sexoitems: ["Masculino", "Femenino"],
      sexoItems: [
        { text: "Masculino", value: "M" },
        { text: "Femenino", value: "F" },
      ],
      ciudades: ["Guayaquil", "Manta", "Salinas", "Quito"],
      loading: false,
      date: "1900-01-01", //new Date().toISOString().substr(0, 10),
      modal: false,
    };
  },
  methods: {
    sendForm() {
      //(this.$refs.form as VForm).validate();
      if ((this.$refs.form as VForm).validate()) {
        const createDto: PersonaCreateDto = {
          correo: this.email,
          tipoIdentificacion: this.tipoid,
          identificacion: this.identificacion,
          nombre: this.nombre,
          apellido: this.apellido,
          sexo: this.sexo,
          telefono: this.telefono,
          fechaNacimiento: this.date,
          password: this.password,
          country: this.country,
          province: this.province,
          canton: this.canton,
        };

        if (this.discapacitado) {
          createDto.carnetConadis = this.carnetConadis;
        }
        AuthStore.register(createDto)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Registro Exitoso",
              text: "Revise su correo para completar el registro",
            }).then(() => {
              this.$router.push("/login");
            });
          })
          .catch(() => {
            this.$swal({
              toast: true,
              position: "bottom-right",
              showConfirmButton: false,
              timer: 1500,
              icon: "error",
              title: "Registro",
              text: "Fallido, usted ya tiene cuenta",
            });
          });
      }
    },
    getIdRules() {
      return null;
    },
    saveFecha(date: any) {
      console.log(date);
    },
    getProvinces() {
      return ProvinciaService.getProvincias().map((p) => p.nombre);
    },
    /**
     *
     */
    getCantones(): any {
      const currentProvince = this.province;

      if (!currentProvince) return [];

      return (
        ProvinciaService.getProvincias()
          .filter((p: any) => p.nombre == currentProvince)[0]
          ?.cantones?.map((c: any) => c.nombre) ?? []
      );
    },
  },
  watch: {
    nombre: function(newVal: string) {
      this.nombre = newVal.toUpperCase();
    },
    apellido: function(newVal: string) {
      this.apellido = newVal.toUpperCase();
    },
    email: function(newVal: string) {
      this.email = newVal.toLowerCase();
    },
  },
  computed: {
    passwordConfirmationRule(): any {
      return () =>
        this.password === this.password2 || "Las contraseñas no coinciden";
    },
    verifyEmail() {
      return (v: string) => v === this.email || "El correo debe coincidir";
    },
    getmaxDate: {
      get(): any {
        const endDate = new Date(
          this.fechaHoy.getFullYear() - 2,
          this.fechaHoy.getMonth(),
          this.fechaHoy.getDate()
        );
        return endDate.toISOString().slice(0, 10);
      },
    },
    getMinDate() {
      return new Date("1900-01-01").toISOString().slice(0, 10);
    },
    fechaNacimientoRules() {
      return [
        (v: string) => {
          const current = new Date(v);
          return (
            (current >= new Date(this.getMinDate) &&
              current <= new Date(this.getmaxDate) && (new Date().getFullYear() - current.getFullYear() <= 120)) ||
            "La fecha de nacimiento es invalida. Verifique que sea correcta."
          );
        }
      ];
    },
    getIdentidadRules: {
      get(): any {
        switch (this.tipoid) {
          case "CED":
            return this.cedulaRules;
          case "RUC":
            return this.rucRules;
          default:
            return this.pasaporteRules;
        }
      },
    }, //end get identidadRules
  },
});
